import { useState, useCallback } from 'react';
import type { ResourceAssetItem } from '../../shared/types';

interface UseAssetPreviewReturn {
  isPreviewOpen: boolean;
  previewAsset: ResourceAssetItem | null;
  previewAssets: ResourceAssetItem[] | null;
  currentAssetIndex: number;
  openPreview: (asset: ResourceAssetItem | ResourceAssetItem[]) => void;
  closePreview: () => void;
  switchAsset: (index: number) => void;
}

export const useAssetPreview = (): UseAssetPreviewReturn => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewAsset, setPreviewAsset] = useState<ResourceAssetItem | null>(null);
  const [previewAssets, setPreviewAssets] = useState<ResourceAssetItem[] | null>(null);
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);

  const openPreview = useCallback((asset: ResourceAssetItem | ResourceAssetItem[]) => {
    if (Array.isArray(asset)) {
      if (asset.length > 0) {
        setPreviewAssets(asset);
        setPreviewAsset(asset[0]);
        setCurrentAssetIndex(0);
        setIsPreviewOpen(true);
      }
    } else {
      setPreviewAssets(null);
      setPreviewAsset(asset);
      setCurrentAssetIndex(0);
      setIsPreviewOpen(true);
    }
  }, []);

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
    setPreviewAsset(null);
    setPreviewAssets(null);
    setCurrentAssetIndex(0);
  }, []);

  const switchAsset = useCallback(
    (index: number) => {
      if (previewAssets && previewAssets[index]) {
        setPreviewAsset(previewAssets[index]);
        setCurrentAssetIndex(index);
      }
    },
    [previewAssets],
  );

  return {
    isPreviewOpen,
    previewAsset,
    previewAssets,
    currentAssetIndex,
    openPreview,
    closePreview,
    switchAsset,
  };
};
